import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    PasswordInput,
    required,
    SelectInput,
    usePermissions,
    ReferenceInput,
} from 'react-admin';
import {
    Alert,
    LinearProgress,
} from '@mui/material';
import { permissionManager } from '../permissions/manager';


export const AdminUserCreate: () => JSX.Element = (): JSX.Element => {
    const { permissions } = usePermissions();

    // This screen had no permission check of any kind, while `AdminUserEdit` at least hid its
    // Roles tab behind a role check. Creating an admin user is refused by HQ-API without
    // `HQ_Admin::admin_users.create`, so the form could only ever have ended in a 403. That was
    // `HQ_Admin::admin_users_manage` until per-verb permissions folded it into the verb.
    //
    // The refusal is spelt out rather than rendering nothing, because most HQ data providers
    // swallow a non-2xx and return an empty result, so a blank screen here would read as a data
    // problem rather than as a permission one.
    if (!permissionManager.isAllowed(permissions, 'HQ_Admin::admin_users.create')) {
        return (
            <Alert severity="warning" sx={ { margin: 2 } }>
                You do not have permission to create an admin user.
            </Alert>
        );
    }

    return (
        <Create>
            <SimpleForm>
                <TextInput name="name" source="name" validate={[required()]} fullWidth />
                <TextInput name="email" source="email" validate={[required()]} fullWidth />
                {/* Set here rather than left for a second visit to the edit screen: an admin
                    created without one holds no ACL role and reaches nothing at all. */}
                <ReferenceInput source="role" reference="admin_roles">
                    <SelectInput
                        label="Access role"
                        optionText="name"
                        helperText="What this admin may reach in HQ. Managed under Admin Roles."
                    />
                </ReferenceInput>
                <PasswordInput name="password" source="password" validate={[required()]} fullWidth />
            </SimpleForm>
        </Create>

    );
}
